<template>
    <v-container>
        <v-card class="pl-10 pr-10">
            <v-card-title>
                <b>{{title}}</b>
                <v-spacer></v-spacer>
                <v-spacer></v-spacer>
                <v-spacer></v-spacer>
                <v-text-field
                    v-model="search"
                    append-icon="search"
                    label="ค้นหา"
                    single-line
                    outlined
                    hide-details>
                </v-text-field>
            </v-card-title>
            <v-divider
                class="mx-4"
                inset
                style="padding-top:10px;"
                ></v-divider>
            <v-data-table
                :headers="headers"
                :items-per-page="5"
                :item-key="itemKey"
                :items="desserts"
                :search="search">

                <template v-slot:top >
                    <v-toolbar flat color="white">
                        <v-spacer></v-spacer>
                        <v-dialog v-model="dialog" :max-width="maxWidth" persistent>
                            <template  v-slot:activator="{ on }">
                                <v-btn color="primary" dark class="mb-2" v-on="on">เพิ่ม</v-btn>
                            </template>
                            <v-card>
                                <v-card-title>
                                    <span class="headline">{{formTitle}}</span>
                                </v-card-title>

                                <v-divider
                                    class="mx-4"
                                    inset
                                    style="padding-top:10px;"
                                    ></v-divider>
                                    
                                <v-card-text>
                                    <v-container>
                                        <v-form ref="form" v-model="valid" lazy-validation>
                                            <slot name="formInput" v-bind:desserts="desserts" v-bind:editedIndex="editedIndex" v-bind:rules="rules"></slot>
                                        </v-form>
                                    </v-container>
                                </v-card-text>

                                <v-card-actions >
                                    <v-spacer></v-spacer>
                                    <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                                    <v-btn color="blue darken-1" text @click="save">Save</v-btn>
                                </v-card-actions>

                            </v-card>
                        </v-dialog>
                    </v-toolbar>
                </template>

                <template v-slot:[`item.action`]="{ item }">
                    <v-icon
                        v-if="updateData"
                        small
                        class="mr-2"
                        @click="viewItem(item)"
                    >
                        {{viewIcon}}
                    </v-icon>
                    <v-icon
                        small
                        @click="deleteItem(item)"
                    >
                        delete
                    </v-icon>
                </template>
            </v-data-table>
        </v-card>
    </v-container>
</template>

<script>
/* eslint-disable */
import {getCurrentPerm} from '@/assets/js/common.js'

export default {
    name: 'MasterTemplate',
    props: ["title", "headers",  "itemKey", "getItemName", "maxDialogWidth",
             "deleteData", "setData", "insertData", "updateData", "listData", "onOpenDialog", "onCloseDialog"
            ],
    watch: {
        dialog(val) {
            if (val) {
                if (typeof this.onOpenDialog === 'function') {
                    this.onOpenDialog(this.editedIndex == -1);
                }
            } else {
                if (typeof this.onCloseDialog === 'function') {
                    this.onCloseDialog();
                }
                
            }
        }
    },
    data: () => ({
        pagination: {
            sortBy: 'name'
        },
        valid: false,
        dialog: false,
        desserts: [],
        editedItem: {},
        defaultItem: {},
        search: '',
        editedIndex: -1,
        rules: {
            required: value => !!value || 'Required.',
            percent:  value => value <= 100 || 'Max value is 100'
        }
    }),
    computed: {
      formTitle() {
        return this.editedIndex === -1 ? 'เพิ่ม' : this.canUpdate ? 'แก้ไข' : this.title;
      },
      viewIcon() {
            return "edit";
      },
      maxWidth() {
          if (!this.maxDialogWidth) {
            return "800px";
          } 
          return this.maxDialogWidth;
      }
    },
    methods: {
        validate() {
            return this.$refs.form.validate();
           //return true;
        },
        close () {
            setTimeout(() => {
                this.$refs.form.resetValidation();
                this.setData(Object.assign({}, this.defaultItem), false);
                this.editedIndex = -1
            }, 300);
            this.dialog = false;
            this.editedIndex = -1
        },
        listItem() {
            this.$loading(true);
            this.listData().then(response => {
                this.$loading(false);
                this.desserts = response;
            }).catch(e => {
                this.$loading(false);
            });
        },
        deleteItem (item) {
            if (confirm('ต้องการลบ ' + this.title + " " + this.getItemName(item) + ' ใช่หรือไม่ ?')) {
                this.deleteData(item).then(response => {
                    const index = this.desserts.indexOf(item);
                    this.desserts.splice(index, 1);
                }).catch((e) => {
                    console.log(e);
                });
            }
        },
        editItem (item) {
            this.editedIndex = this.desserts.indexOf(item);
            this.setData(Object.assign({}, item), true);
            this.dialog = true;
        },
        viewItem (item) {
            this.editedIndex = this.desserts.indexOf(item);
            this.setData(Object.assign({}, item), true);
            this.dialog = true;
        },
        save () {
            if (!this.validate()) {
                return;
            }
            
            this.$loading(true);
            if (this.editedIndex > -1) {
                this.updateData(this.editedItem).then(() => {
                    this.$loading(false);
                    this.close();
                    this.listItem();
                }).catch(e => {
                   this.$loading(false); 
                });
            } else {
                this.insertData(this.editedItem).then(() => {
                    this.$loading(false);
                    this.close();
                    this.listItem();
                }).catch(e => {
                   this.$loading(false); 
                });
            }
        }
    },
    created() {
        this.listItem();
    }
}
</script>